import React, { useState } from "react";
import "./MemberAccessPopup.css";

export default function MembershipPopup({ onClose, onAccessGranted }) {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = () => {
    setError("❌ Invalid Membership Code");
  };

  return (
    <div className="member-popup-overlay">
      <div className="member-popup">
        <h2>Exclusive Access</h2>
        <p>
          This content is reserved for{" "}
          <strong>Degen Den Academy Members</strong>.
        </p>

        <input
          type="text"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          placeholder="Enter your membership code…"
        />

        {error && <div className="popup-error">{error}</div>}

        <div className="popup-buttons">
          <button onClick={handleSubmit}>Submit</button>
          <button onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
}
